import _extends from 'babel-runtime/helpers/extends';
import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import { childrenUtils, createShorthandFactory, customPropTypes, getElementType, getUnhandledProps, META } from '../../lib';

/**
 * A PopupHeader displays a header in a Popover.
 */
export default function PopupHeader(props) {
  var children = props.children,
      className = props.className,
      content = props.content;

  var classes = cx('header', className);
  var rest = getUnhandledProps(PopupHeader, props);
  var ElementType = getElementType(PopupHeader, props);

  return React.createElement(
    ElementType,
    _extends({}, rest, { className: classes }),
    childrenUtils.isNil(children) ? content : children
  );
}

PopupHeader.handledProps = ['as', 'children', 'className', 'content'];
PopupHeader.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};

PopupHeader._meta = {
  name: 'PopupHeader',
  type: META.TYPES.MODULE,
  parent: 'Popup'
};

PopupHeader.create = createShorthandFactory(PopupHeader, function (children) {
  return { children: children };
});


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/modules/Popup/PopupHeader.js
// module id = 1183
// module chunks = 1